import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class SettingsAreasListController extends Controller {
  @service store;
  @service intl;

  queryParams = ['search'];
  @tracked search = '';

  get areas() {
    let areas = this.model;

    if (this.search) {
      areas = areas.filter((area) => {
        return (area.name ?? '')
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    }

    return areas;
  }

  @action
  deleteArea(area) {
    area.destroyRecord();
  }
}
